
import axios from "axios"
import { GETMYRECIVEDSUPPLIER, GETMYSUPPLIERS, GETSUPPLIERS } from "../ActionTypes/SupplierTypes"



export const getSuppliers= ()=>async(dispatch)=>{
try {
   const res = await axios.get('/api/suppliers/getSuppliers')

   dispatch(
{

    type : GETSUPPLIERS,
    payload : res.data.suppliers
}

   )

} catch (error) {
    console.log(error)
}


}

export const addSupplier = (newSupplier, navigate) => async (dispatch) => {
    try {
       await axios.post('/api/suppliers/addSupplier', newSupplier,{
         headers : {
             Authorised : localStorage.getItem('token')
         }
     })
 
       
       dispatch(getSuppliers());
  
      navigate('/Profil');

    } catch (error) {
      console.log(error);
    }
  };



export const getMySuppliers= ()=>async(dispatch)=>{
    try {
       const res = await axios.get('/api/suppliers/getMySupplier',{
        headers : {
            Authorised : localStorage.getItem('token')
        }
    })
    
       dispatch(
    {
    
        type : GETMYSUPPLIERS,
        payload : res.data.mySuppliers
    }
    
       )
    
    } catch (error) {
        console.log(error)
    }
       
    }

    export const getMyRecivedSupplier= ()=>async(dispatch)=>{
        try {
           const res = await axios.get('/api/suppliers/getMyRecivedSupplier',{
            headers : {
                Authorised : localStorage.getItem('token')
            }
        })
        
           dispatch(
        {
        
            type : GETMYRECIVEDSUPPLIER,
            payload : res.data.myRecivedSupplier
        }
        
           )
        
        } catch (error) {
            console.log(error)
        }
        
        
        }
            
export const updateSupplier=(id,upSupplier)=>async(dispatch)=>{
    try {
        console.log('New Supplier', upSupplier )
        await axios.put(`/api/suppliers/updateSupplier/${id}`,upSupplier)

        dispatch(getMyRecivedSupplier())
    } catch (error) {
        console.log(error.res.data)
    }
}